import { render, staticRenderFns } from "./XmPreviewdoc.vue?vue&type=template&id=5b09c248&scoped=true"
import script from "./XmPreviewdoc.vue?vue&type=script&lang=js"
export * from "./XmPreviewdoc.vue?vue&type=script&lang=js"
import style0 from "./XmPreviewdoc.vue?vue&type=style&index=0&id=5b09c248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09c248",
  null
  
)

export default component.exports